import React from 'react';
import PropTypes from 'prop-types';
import utilFunction from '../../containers/function';
import LineChart from '../common/graphs/crossfilterGraphs/lineChart';

const GraphTable = props => (
  <div className="container-graph-table">
    <div className="dc-chart-parent evolution-graph">
      <LineChart
        id={props.id}
        additionalCrossfilterData={null}
        crossfilerData={utilFunction.generateCrossfilter(props.data)}
        stack={false}
        dimension={{
          formatFunction: [[
            'parseDateStringFormat', 
            (props.period.toUpperCase() != "MONTH" ? 
              [`%Y-%m-%d|${props.language.account.date.graphFormatXAxis}`,'%Y-%m-%d'] :
              ['%Y-%m-%d|%m-%Y','%Y-%m'])
          ]],
          name: 'date',
          originalName: 'date',
          reduceFunction: { type: 'DISCRETE_GROUP', fixes: 'FIX_LINE_CHART'}
        }}
        metrics={[
          {
            config: {},
            filter: [],
            formatFunction: [],
            metric: 'value',
            name: 'value',
            reduceFunction: { type: 'AVG' },
            type: 'AVG'
          }
        ]}
        config={{
          tooltip: {
            valuesConfig: [
              {
                identifier: 'x',
                valueFormat: { type: 'STRING', format: 'CLEAN' },
                wrapper: '<div>%v</div>'
              },
              {
                identifier: 'dataValue',
                valueFormat: { type: 'NUMBER', format: '.0f' },
                noDataInfo: `<div><span style='font-weight:bold;'>${props.tooltip.summary.ffdPvt.noData}</span></div>`,
                wrapper: `<div>${
                  props.tooltip.summary.ffdPvt[props.reportType].evTooltip
                }: <span style='font-weight:bold;'>%v%</span></div>`,
                colorRange: [
                  {
                    color: '#41C99F',
                    range: [{ value: props.graphColorRange.good[1], operator: '<' }]
                  },
                  {
                    color: '#F3B119',
                    range: [
                      { value: props.graphColorRange.medium[0], operator: '>=' },
                      { value: props.graphColorRange.medium[1], operator: '<' }
                    ]
                  },
                  {
                    color: '#CC5660',
                    range: [{ value: props.graphColorRange.bad[0], operator: '>=' }]
                  }
                ]
              }
            ]
          },
          renderArea: true,
          showNulls: true,
          interpolation: 'basis',
          stroke: 2.4,
          colors: ['#aeb2b1'],
          dataPoints: { show: true, radius: 2 },
          trendLine: true,
          xAxis: {
            show: false,
            rotation: 0
          },
          yAxis: {
            show: false,
            horizontalLines: false,
            ticksNumber: 2,
            format: '.0f',
            autoRange: { active: false, max: 100, min: 0 }
          }
        }}
        dashboardId={'summary_ffd'}
      />
    </div>
  </div>
);

GraphTable.propTypes = {
  id: PropTypes.PropTypes.string.isRequired
};

export default GraphTable;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_pvt/graphTable.jsx